'use-client';
import * as React from 'react';
import classnames from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { IPreloaderProps } from '../Preloader.types';
import style from './style/Preloader.scss';

const Preloader: React.FC<IPreloaderProps> = props => {
  const { enabled, dark, className } = props;

  return (
    <div
      {...getDataAttributes(props)}
      className={classnames(className, style.preloader, {
        [style.enabled]: !!enabled,
        [style.dark]: !!dark,
      })}
    />
  );
};

export default Preloader;
